/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ModeloFilas from 'Infotrack@Modelos/smartStock/filas';
import IFilas from 'Infotrack@Modelos/smartStock/filas/entidades/filas';
import IFiltrosFilas from 'Infotrack@Modelos/smartStock/filas/entidades/filtrosFilas';

export default class ControladorModeloFilas {
    private modeloFilas: ModeloFilas;
    constructor() {
        this.modeloFilas = new ModeloFilas();
    }

    public consultarFilas() {
        return this.modeloFilas.consultarFilas().then(({ data: { Entidades } }) => Entidades);
    }

    public async crearFilas(filas: IFilas) {
        await this.modeloFilas.crearFilas(filas);
    }

    public async editarFilas(filas: IFilas) {
        await this.modeloFilas.editarFilas(filas);
    }
    public async eliminarFilas(filas: IFilas) {
        await this.modeloFilas.eliminarFilas(filas);
    }

    public async consultarFilasPorFiltro(filas: Partial<IFiltrosFilas>) {
       return  (await this.modeloFilas.consultarListaFilasPorFiltro(filas)).data.Entidades;
    }

    public validarEntidad(filas: IFilas): boolean {
        if (filas.DescripcionFila === '') {
            notificacionGlobal('Por favor ingrese todos los campos requeridos (*)', 6000, 'warning', true);
            return false;
        }
        return true;
    }
}
